"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageNamePlugin = void 0;
exports.PageNamePlugin = {
    name: 'Page Name',
    version: '1.0.0',
    type: 'enrichment',
    load() {
        return Promise.resolve();
    },
    isLoaded() {
        return true;
    },
    page(ctx) {
        if (ctx.event.name) {
            return ctx;
        }
        const title = ctx.event.properties?.['title'];
        if (typeof title === 'string' && title) {
            ctx.event.name = title;
        }
        return ctx;
    },
};
exports.default = exports.PageNamePlugin;
//# sourceMappingURL=page-name.js.map